export const CHATBOT_CONVERSATION_MESSAGE__REQUEST = "CHATBOT_CONVERSATION_MESSAGE__REQUEST";
export const CHATBOT_CONVERSATION_MESSAGE__SUCCESS = "CHATBOT_CONVERSATION_MESSAGE__SUCCESS";
export const CHATBOT_CONVERSATION_MESSAGE__FAILURE = "CHATBOT_CONVERSATION_MESSAGE__FAILURE";

export const NEW_CHATBOT_MESSAGE_REQUEST = "NEW_CHATBOT_MESSAGE_REQUEST";
export const NEW_CHATBOT_MESSAGE_SUCCESS = "NEW_CHATBOT_MESSAGE_SUCCESS";
export const NEW_CHATBOT_MESSAGE_FAILURE = "NEW_CHATBOT_MESSAGE_FAILURE";

export const UPDATE_SINGLE_CHATBOT_MESSAGE_REQUEST = "UPDATE_SINGLE_CHATBOT_MESSAGE_REQUEST";
export const UPDATE_SINGLE_CHATBOT_MESSAGE_SUCCESS = "UPDATE_SINGLE_CHATBOT_MESSAGE_SUCCESS";
export const UPDATE_SINGLE_CHATBOT_MESSAGE_FAILURE = "UPDATE_SINGLE_CHATBOT_MESSAGE_FAILURE";


export const CHATBOT_MESSAGE_FEEDBACK_LIKE_SUCCESS = "CHATBOT_MESSAGE_FEEDBACK_LIKE_SUCCESS";
export const CHATBOT_MESSAGE_FEEDBACK_UNLIKE_SUCCESS = "CHATBOT_MESSAGE_FEEDBACK_UNLIKE_SUCCESS";
export const CHATBOT_MESSAGE_FEEDBACK_REQUEST = "CHATBOT_MESSAGE_FEEDBACK_REQUEST";
export const CHATBOT_MESSAGE_FEEDBACK_FAILURE = "CHATBOT_MESSAGE_FEEDBACK_FAILURE";



export const RESET_CHATBOT = "RESET_CHATBOT";
export const RESET_INTERACTION_FORM = "RESET_INTERACTION_FORM";
export const SELF_CHATBOT_MESSAGE = "SELF_CHATBOT_MESSAGE";
